import { FechaParams } from "../../utils/params/FechaParams.params";
import { EstadisticasCRMDtSourceImplRest } from "../../data/datasources/EstadisticasCRMDtSourceImplRest";
import { EstadisticasCMRRepositoryImpl } from "../../data/repositories/EstadisticasCRMRepositoryImpl";
import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetEstadisticasCRMUseCase } from "../../bussines/useCases/GetEstadisticasCRMUseCase";
import { GetClientesSinContactoUseCase } from "../../bussines/useCases/GetClientesSinContactoUseCase";
import { GetResumenAtencionesUseCase } from "../../bussines/useCases/GetResumenAtencionesUseCase";
import { GetProductosEstadoAnualUseCase } from "../../bussines/useCases/GetProductosEstadoAnualUseCase";

export const useEstadisticasCRM = () => {
    const conceptosDtSourceRest = new EstadisticasCRMDtSourceImplRest();
    const repository = new EstadisticasCMRRepositoryImpl(conceptosDtSourceRest);
    const getEstadisticasCRM = async (input: FechaParams) => {
        const useCase = new GetEstadisticasCRMUseCase(repository);
        const result = await executeUseCase({input, useCase});
        return result;
    }

    const getClientesSinContacto = async (input: FechaParams) => {
        const useCase = new GetClientesSinContactoUseCase(repository);
        const result = await executeUseCase({input, useCase});
        return result;
    }

    const getResumenAtenciones = async (input: FechaParams) => {
        const useCase = new GetResumenAtencionesUseCase(repository);
        const result = await executeUseCase({input, useCase});
        return result;
    }

    const getProductosEstadoAnual = async (input: FechaParams) => {
        const useCase = new GetProductosEstadoAnualUseCase(repository);
        const result = await executeUseCase({input, useCase});
        return result;
    }

    return { getEstadisticasCRM, getClientesSinContacto, getResumenAtenciones, getProductosEstadoAnual }
}